<template>
<div class="happy_nodata">
    <div class="wrap">
        <div class="img_wrap">
            <img src="../../assets/images/parent-course/happyData.png" alt="暂无数据">
        </div>
        <p>暂无数据</p>
    </div>
</div>
</template>

<script>
export default {
  name: 'happy-no',
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="scss">
.happy_nodata {
    // width: 100%;
    // height: 100%;
    .wrap {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .img_wrap {
            width: 233px;
            height: 228px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        p {
            height: 25px;
            // width: 72px;s
            font-size: 18px;
            font-weight: 500;
            color: #fff;
            white-space: nowrap;
        }
    }
}
</style>